import React from 'react';

import {Grid} from '@mui/material';
import {styled} from '@mui/material/styles';

import SwiperCore, {Autoplay, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import Banner from './Banner';

import 'swiper/css/bundle';

const PREFIX = 'Banners';

const classes = {
    containerHolderTop: `${PREFIX}-containerHolderTop`,
    containerHolderMiddle: `${PREFIX}-containerHolderMiddle`,
    containerHolderBottom: `${PREFIX}-containerHolderBottom`,
    swiperContainer: `${PREFIX}-swiperContainer`,
    swiperSlide: `${PREFIX}-swiperSlide`,
    separator: `${PREFIX}-separator`,
};

const StyledGrid = styled(Grid)(({theme: _theme}) => ({
    backgroundColor: _theme.palette.black.main,
    [`& .${classes.containerHolderTop}`]: {
        width: '100%',
        height: '630px',

        '& .swiper-pagination': {
            bottom: 25,
            left: 25,
            display: 'flex',
            justifyContent: 'flex-start',
        },

        '& .swiper-pagination-bullet': {
            width: 25,
            height: 25,
            borderRadius: 0,
            backgroundColor: _theme.palette.white.main,
            opacity: 0.5,
        },

        '& .swiper-pagination-bullet-active': {
            backgroundColor: _theme.palette.orange.main,
            opacity: 1,
        },
    },

    [`& .${classes.containerHolderMiddle}`]: {
        width: '100%',
        height: '630px',

        '& .swiper-pagination': {
            bottom: 165,
            left: 25,
            display: 'flex',
            justifyContent: 'flex-start',
        },

        '& .swiper-pagination-bullet': {
            width: 25,
            height: 25,
            borderRadius: 0,
            backgroundColor: _theme.palette.white.main,
            opacity: 0.5,
        },

        '& .swiper-pagination-bullet-active': {
            backgroundColor: _theme.palette.orange.main,
            opacity: 1,
        },
    },

    [`& .${classes.containerHolderBottom}`]: {
        width: '100%',
        height: '630px',

        '& .swiper-pagination': {
            bottom: 25,
            left: 25,
            display: 'flex',
            justifyContent: 'flex-start',
        },

        '& .swiper-pagination-bullet': {
            width: 25,
            height: 25,
            borderRadius: 0,
            backgroundColor: _theme.palette.white.main,
            opacity: 0.5,
        },

        '& .swiper-pagination-bullet-active': {
            backgroundColor: _theme.palette.orange.main,
            opacity: 1,
        },
    },

    [`& .${classes.swiperContainer}`]: {
        height: '100%',
        backgroundColor: _theme.palette.black.main,
    },

    [`& .${classes.swiperSlide}`]: {
        height: '100%',
    },

    [`& .${classes.separator}`]: {
        height: '14.5px',
        backgroundColor: _theme.palette.black.main,
    },
}));

SwiperCore.use([Pagination, Autoplay]);

const autoplayDelay = 5; // minutes

const getBanners = (banners, pos) => {
    return banners.filter((b) => b.position === pos).sort((a, b) => b.order - a.order);
};

const Banners = ({banners}) => {
    return (
        <StyledGrid container direction="column" alignItems={'stretch'} sx={{height: '100%'}}>
            <Grid item className={classes.containerHolderTop}>
                <Swiper
                    pagination={{clickable: true}}
                    slidesPerView={1}
                    className={classes.swiperContainer}
                    autoplay={{delay: autoplayDelay * 60 * 1000, disableOnInteraction: false}}
                >
                    {getBanners(banners, 'top').map((b, idx) => (
                        <SwiperSlide className={classes.swiperSlide} key={idx}>
                            <Banner banner={b} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>

            <Grid item className={classes.separator} />

            <Grid item className={classes.containerHolderMiddle}>
                <Swiper
                    slidesPerView={1.5}
                    spaceBetween={20}
                    pagination={{clickable: true}}
                    className={classes.swiperContainer}
                    autoplay={{delay: autoplayDelay * 60 * 1000, disableOnInteraction: false}}
                >
                    {getBanners(banners, 'middle').map((b, idx) => (
                        <SwiperSlide key={idx}>
                            <Banner banner={b} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>

            <Grid item className={classes.separator} />

            <Grid item className={classes.containerHolderBottom}>
                <Swiper
                    slidesPerView={1}
                    className={classes.swiperContainer}
                    pagination={{clickable: true}}
                    autoplay={{delay: autoplayDelay * 60 * 1000, disableOnInteraction: false}}
                >
                    {getBanners(banners, 'bottom').map((b, idx) => (
                        <SwiperSlide key={idx}>
                            <Banner banner={b} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>
        </StyledGrid>
    );
};

export default Banners;
